import { LuSquareCheckBig } from "react-icons/lu";

export const bannerItems = [
  {
    id: 1,
    text: "CERTIFIED COACHES",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
  {
    id: 2,
    text: "PROGRESS TRACKING",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
  {
    id: 3,
    text: "1000+ MEMBERS LIVE",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
  {
    id: 4,
    text: "FITNESS TRACKING",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
  {
    id: 5,
    text: "LIVE COACHING",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
  {
    id: 6,
    text: "PERSONALISED PLANS",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
  {
    id: 7,
    text: "EXCLUSIVE DIET PLAN ",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
  {
    id: 8,
    text: " ATHELECTICPERFORMANCE",
    icon: <LuSquareCheckBig color="#2BE71D" />,
  },
];
